import { GateStickyFooter } from '~/modules-rocco/user/component/auth-modal/GateStickyFooter';
import { GATE_CTA_CLASS } from '~/modules-rocco/user/component/auth-modal/gate-cta';

export interface BookMeetingGateDeclinedProps {
    professionalName: string;
    /** The routing rule's message. */
    message: string;
    /** Back to the questions with the answers kept. Omitted when there were none. */
    onChangeAnswers?: () => void;
    onClose: () => void;
}

/**
 * A routing rule turned the answers down: its message in place of a
 * confirmation, laid out as the enquiry gate's decline is.
 */
export const BookMeetingGateDeclined = ({
    professionalName,
    message,
    onChangeAnswers,
    onClose,
}: BookMeetingGateDeclinedProps) => (
    <div
        className="mx-auto my-auto flex w-full max-w-86 flex-col"
        role="status"
        aria-live="polite"
    >
        <h2 className="text-[2.0625rem] leading-[2.125rem] font-medium tracking-[-0.02em] text-[#181818]">
            A note from {professionalName}
        </h2>
        <p className="mt-5 text-[1.1875rem] leading-snug font-medium tracking-[-0.02em] whitespace-pre-wrap text-[#181818]">
            {message}
        </p>
        <p className="mt-4 text-[1.0625rem] leading-snug tracking-[-0.02em] text-[#828282]">
            Your meeting has not been booked.
        </p>
        <GateStickyFooter className="mt-8">
            <button type="button" onClick={onClose} className={GATE_CTA_CLASS}>
                Close
            </button>
            {onChangeAnswers ? (
                <button
                    type="button"
                    onClick={onChangeAnswers}
                    className="mt-4 w-full text-center text-[1.0625rem] tracking-[-0.02em] text-[#44443f]"
                >
                    Change my answers
                </button>
            ) : null}
        </GateStickyFooter>
    </div>
);
